// Unregister any existing service workers to prevent stale SW issues
export const onServiceWorkerUpdateReady = () => {
  window.location.reload()
}

// Clean up old service workers on initial load
export const onClientEntry = () => {
  if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(registrations => {
      registrations.forEach(registration => {
        registration.unregister()
      })
    })
  }
}